angular.module('satv.mediastats')
.factory('Stat', ['config', '$resource', function(config, $resource) {
    return $resource(config.apiUri + '/media/stats', {
        id: '@id'
    }, {
        //here because query doesn't return an array
        query: {
            method: "GET"
        }
    });
}])
;


// WEBPACK FOOTER //
// ./vendor/sonyatv/mediastatsclientbundle/Resources/js/angular/services/Stat.js